import React from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  GameCard,
  Gift,
  CharacterGift,
  BasicCreatureInstance,
  SummonInstance,
  TransformInstance,
} from "@dndModels";

import DandDAPI from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import ButtonBox from "@components/input/buttons/ButtonBox";

interface Props {
  card: GameCard | { true_id: string, name: string, description: string, reshuffle: boolean };
  char?: Character | BasicCreatureInstance | SummonInstance | TransformInstance | null; // I may make this optional in the future.
  name?: string;
  width?: number;
  onApply?: ((amount: number, roll_renders: any[]) => void) | null;
}

const api = DandDAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CardRoller({
  card,
  char = null,
  name = "",
  width = 400,
  onApply = null,
}: Props) {
  if (card instanceof GameCard) {
    let apply_gift: any = null;
    if (card.apply_gift_id !== "" && char) {
      apply_gift = (
        <Grid
          size={{
            xs: 12
          }}>
          <ButtonBox 
            name="Apply to Self"
            onClick={ async () => {
              if (onApply) {
                const res = await api.getFullObject("gift", card.apply_gift_id);
                if (res instanceof Gift && char instanceof Character) {
                  await api.loadObject(res);
                  const char_gift = new CharacterGift();
                  await char_gift.copy_source({ char, feature_source: res });
                  char.spirit.gifts.push(char_gift);
                  char.subscription_holder.recalculate();
                  char.changed();
                  onApply(1, []); 
                }
              }
            }}
          />
        </Grid>
      );
    }
    return (
      <Grid container spacing={0} direction="row" 
        style={{
          background: "black",
          width
        }}>
        { card.image_url !== "" ?
          <Grid
            className='centered'
            size={{
              xs: 12
            }}>
            <img src={ card.image_url } alt={name} className='centered'
              style={{
                maxWidth: width,
                maxHeight: "400px"
              }} 
            />
          </Grid>
        :
          <Grid
            style={{ 
              padding: "4px", 
              // fontSize: "15px",
            }}
            className='centered header'
            size={{
              xs: 12
            }}>
            { card.name }
          </Grid>
        }
        <Grid
          style={{
            verticalAlign: "middle",
            // fontSize: "25px",
            fontWeight: "bold",
            padding: "4px"
          }}
          size={{
            xs: 12
          }}>
          { card.drawn_effect }
        </Grid>
        { apply_gift }
      </Grid>
    );
  } else {
    return (
      <Grid container spacing={0} direction="row" 
        style={{
          background: "black",
          width
        }}>
        {/* { drawn_card.image_url !== "" ?
          <Grid item xs={12} className='centered'>
            <img src={ drawn_card.image_url } alt={name} className='centered'
              style={{
                maxWidth: "400px",
                maxHeight: "400px"
              }} 
            />
          </Grid>
        : */}
        <Grid
          style={{ 
            padding: "4px", 
            // fontSize: "15px",
          }}
          className='centered header'
          size={{
            xs: 12
          }}>
          { card.name }
        </Grid>
        {/* } */}
        <Grid
          style={{
            verticalAlign: "middle",
            // fontSize: "25px",
            fontWeight: "bold",
            padding: "4px"
          }}
          size={{
            xs: 12
          }}>
          { card.description }
        </Grid>
      </Grid>
    );
  }
}
